import MainLayout from "../components/layout/MainLayout";
import './POC.css';
import {App, Button, Col, Row, Typography} from "antd";
import {ArrowRightOutlined, CheckCircleFilled} from "@ant-design/icons";
import PanelFrameWithImage from "../components/panels/PanelFrameWithImage";
import {imageLocations} from "../components/image/ImageLocations";
import BannerPanel from "../components/panels/BannerPanel";
import PanelFrame from "../components/panels/PanelFrame";
import MyVehiclePanel from "../components/panels/MyVehiclePanel";
import {useEffect, useState} from "react";
import {getContracts} from "../api/contracts";
import {showApiError} from "../utility/error/error-handler";
import {useTranslation} from "react-i18next";


const { Text} = Typography;


// PLEASE NOTE -------------------------------------------------------------
// There are no translations in this demo page. If copying or reusing code,
// please translate button labels and titles and so on as appropriate.
// - see the Login page or the Wiki for examples.
// -------------------------------------------------------------------------


const POC = () => {
    const { t } = useTranslation();
    const { notification } = App.useApp();
    const [vehicle, setVehicle] = useState(null);

    const [contracts, setContracts] = useState([]);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        getContracts()
            .then(res => {
                // setLoading(false);
                setContracts(res);
                if(res.length > 0)
                {
                    setVehicle(res[0].contractVehicle);
                }}, )
            .catch(err => showApiError(t('title.my_vehicles'), err, notification));
    }, [t, notification]);

    return (
        <MainLayout showSubHeader={true} startHigher="200px" subHeaderContent={<MyVehiclePanel contracts={contracts}  onChange={(vehicle) => {console.log(vehicle); setVehicle(vehicle);}}/>} footerShowReturnToTop={true}>
            <Row>
                <Col flex="100%">
                    {/*Quoting*/}
                    <PanelFrame title="Quoting">
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col>
                                <Row className="quote-highlight"><Text>Your vehicle is eligible for renewal!</Text></Row>
                                <Row><Text>Current contract expires in 6 months' time on the 11th of October 2024</Text></Row>
                                <Row className="quote-policy">
                                    <Text style={{ fontWeight: '600', marginRight: '5px' }}>Grade:</Text>
                                    <Text>Band 2 Sales</Text>
                                    <Button size="small" style={{ marginLeft: '10px' }}>View Policy</Button>
                                </Row>
                            </Col>
                            <Col>
                                <Button type="primary">New Quote</Button>
                                <Button>My Quotes</Button>
                            </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                            <BannerPanel title="Recent Quotations">
                                <div>
                                    <Text>No active quotes</Text>
                                </div>
                            </BannerPanel>
                        </Row>
                    </PanelFrame>
                </Col>
            </Row>
            <Row justify="space-between">
                {/*Maintenance Booking*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                    <PanelFrameWithImage title="Request a Maintenance Booking"
                                         imageLocation={imageLocations.CAR_MAINTENANCE_BONNET_IMAGE}
                                         backgroundType="default" height="210px">
                        <div>
                            <Row><Text>Estimated next service - LR55TYH</Text></Row>
                            <Row align="middle"><ArrowRightOutlined className="bullet-list-arrow" /><Text>24th April 2024</Text></Row>
                            <Row align="middle"><ArrowRightOutlined className="bullet-list-arrow" /><Text>30,000 mile service</Text></Row>
                            <Row align="middle"><ArrowRightOutlined className="bullet-list-arrow" /><Text>Oil Change</Text></Row>
                            <Row style={{ marginTop: '20px' }}>
                                <Button type="primary">Request Booking</Button>
                                <Button>Maintenance History</Button>
                            </Row>
                        </div>
                    </PanelFrameWithImage>
                </Col>
                {/*Tyres*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                    <PanelFrameWithImage title="Replace My Tyres"
                                         imageLocation={imageLocations.TYRES_FOR_PURCHASE_IMAGE}
                                         backgroundType="default" height="210px">
                        <div>
                            <Row><Text>Nearest Tyre Centre:</Text></Row>
                            <Row align="top">
                                <ArrowRightOutlined className="bullet-list-arrow" style={{ marginTop: '5px' }} />
                                <Text style={{ whiteSpace: 'pre-line', lineHeight: '20px' }}>{`Carden Street \nWorcester \nWR1 2AT`}</Text></Row>
                            <Row style={{ marginTop: '26px' }}>
                                <Button type="primary">Request Booking</Button>
                                <Button>View Map</Button>
                            </Row>
                        </div>
                    </PanelFrameWithImage>
                </Col>
            </Row>
            <Row justify="space-between">
                {/*Accident*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                    <PanelFrameWithImage title="Manage My Accident"
                                         imageLocation={imageLocations.CAR_BUMPER_DENT_IMAGE}
                                         backgroundType="default" height="190px">
                        <div>
                            <Row align="middle">
                                <CheckCircleFilled className="status_icon_accident" />
                                <Text>No claims currently in progress</Text>
                            </Row>
                            <Row style={{ marginTop: '46px' }}>
                                <Button type="primary">Request New Accident</Button>
                            </Row>
                        </div>
                    </PanelFrameWithImage>
                </Col>
                {/*Carbon Footprint*/}
                <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                    <PanelFrameWithImage title="My Carbon Footprint"
                                         imageLocation={imageLocations.GREEN_FOOTPRINT_IMAGE}
                                         backgroundType="alternate" height="190px">
                        <div>
                            <Row align="middle" style={{ width: '350px' }}>
                                <Col className="carbon-footprint-label" span={8}>
                                    <Text>Carbon Footprint</Text>
                                </Col>
                                <Col className="carbon-footprint-main" span={7}>
                                    <Text>575.2349</Text>
                                </Col>
                                <Col className="carbon-footprint-unit" span={6}>
                                    <Text>tons of CO<sub>2</sub>/e</Text>
                                </Col>
                            </Row>
                            <Row align="middle" style={{ width: '350px' }}>
                                <Col className="carbon-footprint-label" span={8}>
                                    <Text>Average tones / 1k miles</Text>
                                </Col>
                                <Col className="carbon-footprint-other" span={7}>
                                    <Text>0.2013</Text>
                                </Col>
                                <Col className="carbon-footprint-unit" span={6}>
                                    <Text>tones of CO<sub>2</sub>/e</Text>
                                </Col>
                            </Row>
                            <Row align="middle" style={{ width: '350px' }}>
                                <Col className="carbon-footprint-label" span={8}>
                                    <Text>Average vehicle CO<sub>2</sub></Text>
                                </Col>
                                <Col className="carbon-footprint-other" span={7}>
                                    <Text>134.5</Text>
                                </Col>
                                <Col className="carbon-footprint-unit" span={6}>
                                    <Text>g/mile</Text>
                                </Col>
                            </Row>
                        </div>
                    </PanelFrameWithImage>
                </Col>
            </Row>
            <Row>
                {/*Submit Odo*/}
                <Col style={{ width: '100%' }}>
                    <PanelFrameWithImage title="Submit Odometer Reading"
                                         imageLocation={imageLocations.OLD_ODOMETER_IMAGE}
                                         backgroundType="filled" height="190px" imageWidth="560px">
                        <div>
                            <Row><Text style={{ color: 'var(--dp-panel-text-filled-colour)' }}>Highest Recorded Odo - LR55TYH</Text></Row>
                            <Row align="middle">
                                <ArrowRightOutlined className="bullet-list-arrow" style={{ color: 'rgba(255, 255, 255, 0.6)' }} />
                                {vehicle
                                ?
                                <Text style={{ color: 'var(--dp-panel-text-filled-colour)' }}>{vehicle.regNo}</Text>
                                :
                                <></>}
                            </Row>
                            <Row align="middle">
                                <ArrowRightOutlined className="bullet-list-arrow" style={{ color: 'rgba(255, 255, 255, 0.6)' }} />
                                <Text style={{ color: 'var(--dp-panel-text-filled-colour)' }}>27,589 miles</Text>
                            </Row>
                            <Row style={{ marginTop: '20px' }}>
                                <Button type="default">Submit Odo</Button>
                            </Row>
                        </div>
                    </PanelFrameWithImage>
                </Col>
            </Row>
        </MainLayout>
    );
}

export default POC;